/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Percent_Platform_FeesInputs */

const en_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% platform fees`)
};

const es_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% de comisiones de plataforma`)
};

const fr_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% de frais de plateforme`)
};

const de_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% Plattformgebühren`)
};

const ja_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`手数料${i?.fee}%のプラットフォームを利用する`)
};

const zh_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% 平台费`)
};

const ar_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`رسوم منصة بنسبة %`)
};

const id_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% biaya platform`)
};

const it_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% di commissioni della piattaforma`)
};

const ru_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% комиссия платформы`)
};

const pt_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% de taxas de plataforma`)
};

const ko_percent_platform_fees = /** @type {(inputs: Percent_Platform_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`% 플랫폼 수수료`)
};

/**
* | output |
* | --- |
* | "% platform fees" |
*
* @param {Percent_Platform_FeesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const percent_platform_fees = /** @type {((inputs: Percent_Platform_FeesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Percent_Platform_FeesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_percent_platform_fees(inputs)
	if (locale === "es") return es_percent_platform_fees(inputs)
	if (locale === "fr") return fr_percent_platform_fees(inputs)
	if (locale === "de") return de_percent_platform_fees(inputs)
	if (locale === "ja") return ja_percent_platform_fees(inputs)
	if (locale === "zh") return zh_percent_platform_fees(inputs)
	if (locale === "ar") return ar_percent_platform_fees(inputs)
	if (locale === "id") return id_percent_platform_fees(inputs)
	if (locale === "it") return it_percent_platform_fees(inputs)
	if (locale === "ru") return ru_percent_platform_fees(inputs)
	if (locale === "pt") return pt_percent_platform_fees(inputs)
	return ko_percent_platform_fees(inputs)
});